// extracted by mini-css-extract-plugin
export default {"note":"styles_note__VUnk6","link":"styles_link__IGXmT","iconBlock":"styles_iconBlock__a6jnD","textBlock":"styles_textBlock__UmLiU"};